<template>
  <div class="">
    <b-card
      :img-src="person.imgSrc"
      img-alt="Image"
      img-top
      class="mb-5 member-card"
    >
      <b-card-title
        class="font-weight-bold f-s-18 l-h-153-p l-s-175 black-1"
      >
        {{ person.fullName }}
      </b-card-title>
      <b-row>
        <b-col cols="10">
          <b-card-text class="f-s-14 l-h-153-p l-s-0_08 main-grey">
            {{ person.position }}
          </b-card-text>
        </b-col>
        <b-col cols="1">
          <span />
          <b-link
            :href="person.linkedInAddress"
            target="_blank"
          >
            <i class="i-in cursor-pointer" />
          </b-link>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'TeamMemberCard',
  props: {
    person: {
      type: Object,
      required: true,
      default: null,
    },
  },
};
</script>
